/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Filter,
  GetAccountMembershipContactEmails200Response,
  GetAccountMembershipContactPhones200Response,
  GetAccountMembershipRelatives200Response,
  GetMemberData200Response,
  ListAccountsOrderParameterInner,
  ListCampsitesForMember200Response,
  ListMemberData200Response,
} from '../models/index';
import {
    FilterFromJSON,
    FilterToJSON,
    GetAccountMembershipContactEmails200ResponseFromJSON,
    GetAccountMembershipContactEmails200ResponseToJSON,
    GetAccountMembershipContactPhones200ResponseFromJSON,
    GetAccountMembershipContactPhones200ResponseToJSON,
    GetAccountMembershipRelatives200ResponseFromJSON,
    GetAccountMembershipRelatives200ResponseToJSON,
    GetMemberData200ResponseFromJSON,
    GetMemberData200ResponseToJSON,
    ListAccountsOrderParameterInnerFromJSON,
    ListAccountsOrderParameterInnerToJSON,
    ListCampsitesForMember200ResponseFromJSON,
    ListCampsitesForMember200ResponseToJSON,
    ListMemberData200ResponseFromJSON,
    ListMemberData200ResponseToJSON,
} from '../models/index';

export interface ExportMemberDataRequest {
    filters?: Array<Filter>;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface GetMemberDataRequest {
    memberID: string;
}

export interface ListCampsitesForMemberRequest {
    memberID: string;
    filters?: Array<Filter>;
    pageNumber?: number;
    pageSize?: number;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface ListMemberDataRequest {
    filters?: Array<Filter>;
    pageNumber?: number;
    pageSize?: number;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface ListMemberEmailsRequest {
    memberID: string;
    filters?: Array<Filter>;
    pageNumber?: number;
    pageSize?: number;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface ListMemberPhonesRequest {
    memberID: string;
    filters?: Array<Filter>;
    pageNumber?: number;
    pageSize?: number;
    order?: Array<ListAccountsOrderParameterInner>;
}

export interface ListRelativesForMemberRequest {
    memberID: string;
    filters?: Array<Filter>;
    pageNumber?: number;
    pageSize?: number;
    order?: Array<ListAccountsOrderParameterInner>;
}

/**
 * 
 */
export class MemberDataApi extends runtime.BaseAPI {

    /**
     * Export member data
     * Export Member Data
     */
    async exportMemberDataRaw(requestParameters: ExportMemberDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/member-data/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Export member data
     * Export Member Data
     */
    async exportMemberData(requestParameters: ExportMemberDataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportMemberDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get member
     * Get Member
     */
    async getMemberDataRaw(requestParameters: GetMemberDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMemberData200Response>> {
        if (requestParameters['memberID'] == null) {
            throw new runtime.RequiredError(
                'memberID',
                'Required parameter "memberID" was null or undefined when calling getMemberData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/member-data/{memberID}`.replace(`{${"memberID"}}`, encodeURIComponent(String(requestParameters['memberID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMemberData200ResponseFromJSON(jsonValue));
    }

    /**
     * Get member
     * Get Member
     */
    async getMemberData(requestParameters: GetMemberDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMemberData200Response> {
        const response = await this.getMemberDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List campsites for member
     * List Campsites for Member
     */
    async listCampsitesForMemberRaw(requestParameters: ListCampsitesForMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCampsitesForMember200Response>> {
        if (requestParameters['memberID'] == null) {
            throw new runtime.RequiredError(
                'memberID',
                'Required parameter "memberID" was null or undefined when calling listCampsitesForMember().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/member-data/{memberID}/campsites`.replace(`{${"memberID"}}`, encodeURIComponent(String(requestParameters['memberID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCampsitesForMember200ResponseFromJSON(jsonValue));
    }

    /**
     * List campsites for member
     * List Campsites for Member
     */
    async listCampsitesForMember(requestParameters: ListCampsitesForMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCampsitesForMember200Response> {
        const response = await this.listCampsitesForMemberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List member data
     * List Member Data
     */
    async listMemberDataRaw(requestParameters: ListMemberDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListMemberData200Response>> {
        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/member-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListMemberData200ResponseFromJSON(jsonValue));
    }

    /**
     * List member data
     * List Member Data
     */
    async listMemberData(requestParameters: ListMemberDataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListMemberData200Response> {
        const response = await this.listMemberDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List member emails
     * List Member Emails
     */
    async listMemberEmailsRaw(requestParameters: ListMemberEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountMembershipContactEmails200Response>> {
        if (requestParameters['memberID'] == null) {
            throw new runtime.RequiredError(
                'memberID',
                'Required parameter "memberID" was null or undefined when calling listMemberEmails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/member-data/{memberID}/emails`.replace(`{${"memberID"}}`, encodeURIComponent(String(requestParameters['memberID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountMembershipContactEmails200ResponseFromJSON(jsonValue));
    }

    /**
     * List member emails
     * List Member Emails
     */
    async listMemberEmails(requestParameters: ListMemberEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountMembershipContactEmails200Response> {
        const response = await this.listMemberEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List member phones
     * List Member Phones
     */
    async listMemberPhonesRaw(requestParameters: ListMemberPhonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountMembershipContactPhones200Response>> {
        if (requestParameters['memberID'] == null) {
            throw new runtime.RequiredError(
                'memberID',
                'Required parameter "memberID" was null or undefined when calling listMemberPhones().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/member-data/{memberID}/phones`.replace(`{${"memberID"}}`, encodeURIComponent(String(requestParameters['memberID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountMembershipContactPhones200ResponseFromJSON(jsonValue));
    }

    /**
     * List member phones
     * List Member Phones
     */
    async listMemberPhones(requestParameters: ListMemberPhonesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountMembershipContactPhones200Response> {
        const response = await this.listMemberPhonesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List relatives for member
     * List Relatives for Member
     */
    async listRelativesForMemberRaw(requestParameters: ListRelativesForMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountMembershipRelatives200Response>> {
        if (requestParameters['memberID'] == null) {
            throw new runtime.RequiredError(
                'memberID',
                'Required parameter "memberID" was null or undefined when calling listRelativesForMember().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = JSON.stringify(requestParameters['filters']);
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['page[number]'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page[size]'] = requestParameters['pageSize'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = JSON.stringify(requestParameters['order']);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/member-data/{memberID}/relatives`.replace(`{${"memberID"}}`, encodeURIComponent(String(requestParameters['memberID']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountMembershipRelatives200ResponseFromJSON(jsonValue));
    }

    /**
     * List relatives for member
     * List Relatives for Member
     */
    async listRelativesForMember(requestParameters: ListRelativesForMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountMembershipRelatives200Response> {
        const response = await this.listRelativesForMemberRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
